import API from './api';

export const fetchInfos = () =>
  API.get('/Consultancy/infos')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listAppointments = () =>
  API.get('/Consultancy/appointments')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const cancelAppointment = id =>
  API.delete(`/Consultancy/appointments/${id}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listProfessionals = () =>
  API.get('/consultants')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const fetchProfessional = id =>
  API.get(`/consultant/${id}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const sendRating = ({ appointmentId, rating, comments }) =>
  API.post(`/evaluation/${appointmentId}`, {
    rating,
    comments,
  })
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listScheduleTimeTable = () =>
  API.get(`/Consultancy/timetable`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listScheduleColumns = ({ startDate, endDate, filters }) => {
  const profissionalId = filters?.professional;
  return API.post(`/Consultancy/ConsultancySchedule`, {
    profissionalId,
    startTime: startDate,
    endTime: endDate,
  })
    .then(res => res)
    .catch(err => {
      throw err;
    });
};

export const sendAppointment = ({
  timeTableId,
  columnDate,
  professionalId,
  meetingId,
  contact,
  mainDoubt,
}) =>
  API.post(`/Consultancy/CreateSchedule/${timeTableId}`, {
    date: columnDate,
    consultantId: professionalId,
    mettingId: meetingId,
    skype: contact,
    quest: mainDoubt,
  })
    .then(res => res)
    .catch(err => {
      throw err;
    });
